import photo_1 from "./EverestPictures/Photo-01.webp";
import photo_2 from "./EverestPictures/Photo-02.webp";
import photo_3 from "./EverestPictures/Photo-03.webp";

export const EverestPhotoContent = [
  {
    id: 1,
    title: "Photos",
    latestPicture: {
      image: photo_1,
      date: "14 June 2025",
      time: "9:13am",
      location: "Mt.Everest Summit",
    },
    pictures: [
      {
        image: photo_1,
        date: "14 June 2025",
        time: "9:13am",
        location: "Mt.Everest Summit",
      },
      {
        image: photo_2,
        date: "14 June 2025",
        time: "1:42pm",
        location: "",
      },
      {
        image: photo_3,
        date: "14 June 2025",
        time: "1:46pm",
        location: "",
      },
    ],
  },
];
